import React from 'react'
import './Productos.css'
import Header from '../Header/Header'
import ProductosData from '../../components/Admin/ProductosData/ProductosData'
import HeaderDash from '../../components/Admin/HeaderDash/HeaderDash'
export default function Productos({ logo }) {
    return (
        <div className='containerGrid'>
            <Header logo={logo} />

            <section className='containerSection'>

                <HeaderDash />
                <div className='container'>
                    <ProductosData />
                </div>
            </section>
        </div>
    )
}
